import { Fragment, useLayoutEffect } from 'react';
import type { Chat } from '@trinity/chat';
import { ChatItem } from './Item';
import { useChatPermissions } from './hooks/useChatPermissions';
import { useScrollToBottomOfMessages } from './hooks/useScrollMessageList';

type Props = {
  items: Chat.InstanceItem[];
};

export const MessageList = ({ items }: Props) => {
  const scrollToBottom = useScrollToBottomOfMessages();
  const chatPermissions = useChatPermissions();

  useLayoutEffect(() => {
    scrollToBottom();
  }, [scrollToBottom]);

  const view = {
    regenerate: chatPermissions.canModify,
  };

  return (
    <Fragment>
      {items.map((item, i) => (
        <ChatItem
          key={i}
          canRegenerate={view.regenerate && i === items.length - 1}
          item={item} />
      ))}
    </Fragment>
  );
};